
import { Component, Vue, Prop } from 'vue-property-decorator';
import { TreeNode } from '@/modules/nomenclature/models/treeNode';

@Component({
  components: {}
})
export default class DeleteLocationForm extends Vue {
  @Prop({ required: true })
  protected value!: TreeNode;
  @Prop({ required: true })
  protected deleteCallBack!: (locationId: string, onDeleteCascade: boolean, oldLocation: TreeNode) => Promise<void>;
  protected sendingRequest = false;
  protected requestError = false;
  protected requestErrorChildren = false;
  protected onDeleteCascade = false;

  protected deleteLocation(): void {
    this.sendingRequest = true;
    setTimeout(() => {
      this.deleteCallBack(this.value.id as string, this.onDeleteCascade, this.value)
        .then(() => {
          this.$emit('cancel');
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.requestErrorChildren = true;
            this.onDeleteCascade = true;
          } else {
            this.requestError = true;
          }
        })
        .finally(() => (this.sendingRequest = false));
    }, 500);
  }

  protected cancel(): void {
    this.requestError = false;
    this.requestErrorChildren = false;
    this.onDeleteCascade = false;
    this.$emit('cancel');
  }
}
